export default __webpack_public_path__ + "static/media/fotos.1445349e.svg";